var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_c('transition',{attrs:{"name":"slide-up"}},[(!_vm.meshIsAccessory(_vm.selectedMesh))?_c('fabric-grid',{attrs:{"items":_vm.fabrics}}):_c('div',[_c('p',[_vm._v("Fabric not available for this selection.")])])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }